import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import MediaAnalysis from '@/views/tests/MediaAnalysis';
import MediaAnalysisSingle from '@/views/tests/MediaAnalysisSingle';
import MediaAnalysisReport from '@/views/tests/MediaAnalysisReport';

export default {
  path: 'media',
  component: MediaAnalysis,
  name: 'tests-media',
  meta: { title: 'Media Analysis' },
  children: [
    {
      path: 'new',
      name: 'tests-media-new',
      component: MediaAnalysisSingle,
      meta: { title: 'Media Analysis' },
    },
    {
      path: ':test',
      name: 'tests-media-single',
      component: MediaAnalysisSingle,
      meta: { title: 'Media Analysis' },
    },
    {
      path: ':test/report',
      name: 'tests-media-single-report',
      component: MediaAnalysisReport,
      meta: { title: 'Media Analysis Report' },
    },
  ]
};
